import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum SellerFilterKeys {
  status = "status"
}

export interface SellerListFilterOpts {
  status: FilterOpts<SmopStatusEnum>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "Active Seller"
  },
  deleted: {
    defaultMessage: "Delete",
    description: "Delete Seller"
  },
  inactive: {
    defaultMessage: "Inactive",
    description: "Deactivated Seller"
  },
  status: {
    defaultMessage: "Status",
    description: "Seller Status"
  },
  underreview: {
    defaultMessage: "Under Review",
    description: "Unde Review Seller"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: SellerListFilterOpts
): IFilter<SellerFilterKeys> {
  return [
    {
      ...createOptionsField(
        SellerFilterKeys.status,
        intl.formatMessage(messages.status),
        [opts.status.value],
        false,
        [
          {
            label: intl.formatMessage(messages.active),
            value: SmopStatusEnum.ACT
          },
          {
            label: intl.formatMessage(messages.inactive),
            value: SmopStatusEnum.INA
          },
          {
            label: intl.formatMessage(messages.underreview),
            value: SmopStatusEnum.RVW
          }
        ]
      ),
      active: opts.status.active
    }
  ];
}
